var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 18.375L21 3.5L4.375 18.375",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 29.75V38.5H8.75V29.75",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.625H12.25V38.5H17.5V30.625Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 30.625H21V35H29.75V30.625Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14C22.933 14 24.5 13.2165 24.5 12.25C24.5 11.2835 22.933 10.5 21 10.5C19.067 10.5 17.5 11.2835 17.5 12.25C17.5 13.2165 19.067 14 21 14Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.375V14",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 18.375V14",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.375L7 23.625H35L32.375 18.375H9.625Z",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.625L15.75 18.375",
    stroke: "#065699",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.375L28 23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.375V23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.625V24.5C7 25.4283 7.36875 26.3185 8.02513 26.9749C8.6815 27.6313 9.57174 28 10.5 28C11.4283 28 12.3185 27.6313 12.9749 26.9749C13.6313 26.3185 14 25.4283 14 24.5V23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.625V24.5C14 25.4283 14.3687 26.3185 15.0251 26.9749C15.6815 27.6313 16.5717 28 17.5 28C18.4283 28 19.3185 27.6313 19.9749 26.9749C20.6313 26.3185 21 25.4283 21 24.5V23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.625V24.5C21 25.4283 21.3687 26.3185 22.0251 26.9749C22.6815 27.6313 23.5717 28 24.5 28C25.4283 28 26.3185 27.6313 26.9749 26.9749C27.6313 26.3185 28 25.4283 28 24.5V23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.625V24.5C28 25.4283 28.3687 26.3185 29.0251 26.9749C29.6815 27.6313 30.5717 28 31.5 28C32.4283 28 33.3185 27.6313 33.9749 26.9749C34.6313 26.3185 35 25.4283 35 24.5V23.625",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressHome);
export default __webpack_public_path__ + "static/media/addressHome.8e2f1647ca255c1d183c1fff21ec6a66.svg";
export { ForwardRef as ReactComponent };